export const UPDATE_INFO = {
    EMAIL: 'Email',
    PASSWORD: 'Password',
    PHONE: 'Phone',
}

export const SIGN_STATUS = {
    EN_COURS: 'EN_COURS',
    FINALISATION: 'FINALISATION',
    SUCCES: 'SUCCES',
    ECHEC: 'ECHEC'
}
